"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
var core_1 = require("@material-ui/core");
var theme_1 = require("../../theme");
exports.useStyles = makeStyles_1.default(function (theme) {
    return core_1.createStyles({
        paper: {
            padding: 30,
            position: 'absolute',
            width: 400,
            height: 250,
            backgroundColor: theme.palette.background.paper,
            border: "2px solid " + theme_1.contrast().secondary,
            outline: 0,
            boxShadow: theme.shadows[5],
        },
        modal: {
            padding: 20,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
    });
});
//# sourceMappingURL=ConfirmationModalStyle.js.map